import React, { useState } from 'react';
import { toast } from 'react-toastify';

// JS Files
import useFetch from '../../../context/useFetch';
import { useUserData } from '../../../context/UserDataContext';
import MuiComboBox from '../../shares/MuiComboBox';
import { useLocation } from 'react-router-dom';

const TabZero = (props) => {
  const { userData } = useUserData();
  const location = useLocation();

  const [searchedCustomerText, setSearchedCustomerText] = useState(
    location.state != null ? location.state.userInfo.username : ''
  );
  const [adminCustomersList, setAdminCustomersList] = useState({ results: [] });

  const getListOfCustomerApi = useFetch({
    method: 'post',
    url: `User_Service/${userData.username}/admin_search_user`,
    data: { user: searchedCustomerText },
    // trigger: location.state != null ? true : false,
    trigger:  true,
    argFunc: (res) => {
      setAdminCustomersList(res);
    },
    errMessage: (mess) => {
      toast.error('خطایی رخ داده است', {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handleSearchedCustomerText = (text) => {
    setSearchedCustomerText(text);
    // if (text.length >= 1) {
      getListOfCustomerApi.reFetch();
    // }
  };

  return (
    <>
      {props.selectedUser !== undefined ? (
        <div className="mb-4">
          <span className="text-myblue-100">
            مشتری انتخاب شده:{' '}
            <span className="text-gray-700">{props.selectedUser?.name}</span>
          </span>
        </div>
      ) : (
        ''
      )}

      <div className="grid md:grid-cols-3 gap-x-4 items-center mt-4">
        <span className="">مشتری را انتخاب کنید:</span>
        <MuiComboBox
          size="small"
          label="مشتری"
          labelId="customer-search-label"
          id="customer-search-select"
          selectedUser={props.selectedUser}
          setSelectedUser={props.setSelectedUser}
          options={adminCustomersList.results}
          placeholder="نام مشتری"
          setSelectedOption={props.setSelectedCustomer}
          setSearchText={handleSearchedCustomerText}
          forUser
          baseUsername
          haveSetSelectedUser
          selectedOption={props.selectedCustomer}
        />
      </div>
    </>
  );
};

export default TabZero;
